module.exports = __webpack_public_path__ + "static/media/icon-plus.aad7d7b2.svg";